class Confirm
  @success: (title, text, buttons) -> new Confirm('success', title, text, buttons).call()
  @error: (title, text, buttons) -> new Confirm('error', title, text, buttons).call()
  @warning: (title, text, buttons) -> new Confirm('warning', title, text, buttons).call()
  @info: (title, text, buttons) -> new Confirm('info', title, text, buttons).call()

  constructor: (@type, @title, @text, @buttons = {}, call = true) -> angular.noop

  getColor = (type) ->
    switch type
      when 'success' then 'rgb(115, 158, 115)'
      when 'error' then 'rgb(196, 106, 105)'
      when 'warning' then 'rgb(199, 145, 33)'
      when 'info' then 'rgb(50, 118, 177)'
      else 'rgb(50, 118, 177)'

  getIcon = (type) ->
    switch type
      when 'success' then 'fa fa-check'
      when 'error' then 'fa fa-frown-o'
      when 'warning' then 'fa fa-exclamation-triangle'
      when 'info' then 'fa fa-info-circle'
      else ''

  call: ->
    @color = if @color? then @color else getColor(@type)
    @icon = if @icon? then @icon else getIcon(@type)

    configs =
      title: "<strong style='color: #{@color}'><i class='#{@icon}'></i>&nbsp;&nbsp;#{@title}</strong>"
      content: @text
      sound: false
      buttons: ("[#{button}]" for button, callback of @buttons).join ''

    new Promise((resolve) =>
      $.SmartMessageBox(configs,
        (pressed) =>
          if @buttons[pressed]
            result = @buttons[pressed]()

            if result?.then
              result.then(resolve)
            else
              resolve(result)
      )
    )

angular.module('eficienciaFiscalModule').factory('Confirm', -> Confirm)

window.Confirm = Confirm
